import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var drag_handle_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M8 7h2V5H8v2zm0 6h2v-2H8v2zm0 6h2v-2H8v2zm6-14v2h2V5h-2zm0 8h2v-2h-2v2zm0 6h2v-2h-2v2z" }) });
export {
  drag_handle_default as default
};
//# sourceMappingURL=drag-handle.js.map
